const CHANGE_INPUT_FIELD = 'CHANGE_INPUT_FIELD';

export default CHANGE_INPUT_FIELD;
